<template>
	<div class="home-wrapper">
		<h2 class="page-title"> {{ $t('overview') }}</h2>
		<el-divider></el-divider>
		<el-link style="font-size: 30px;margin : 10px;">{{ $t("greeting") }}，{{ user.name }}</el-link>
		<div style="width: 100%;height:120px;background-color: antiquewhite;padding-left: 15px;border-radius: 5px; ">
			<table style="height: 120px; width: 100%;margin-top: 10px; text-align: left;">
				<!--c
				<tr>
					<th style="width: 13%;">已訂購服務計劃</th>
					<th style="width: 10%;">企業會員系統方案</th>
					<th style="width: 15%;"></th>
					<th></th>
					<th style="width: 13%;">服務週期</th>
					<th style="width: 35%;">06/12/2023---28/12/2024</th>
				</tr>-->

				<!--
				<tr>
					<th style="width: 13%;">餘額</th>
					<th style="width: 10%;">{{user.balance}}</th>
					<th style="width: 15%;">
						<el-button @click="goToPay()">增值</el-button>
					</th>
					<th></th>
					<th style="width: 13%;">商戶ID</th>
					<th style="width: 35%;">{{qyid}}</th>
				</tr>-->

				<tr>
					<th style="width: 13%;">{{ $t("merchantid") }}</th>
					<th style="width: 10%;">{{ qyid }}</th>
				</tr>
				<tr>
					<th style="width: 13%;">{{ $t("memberTotal") }}</th>
					<th style="width: 10%;">{{ this.numberConfig[2].value }}</th>
					<th style="width: 15%;">
					</th>
					<th></th>
					<th style="width: 13%;">
						<template v-if="storeList.length < 1 && loadingStore == false">商戶QR/海報</template>
					</th>
					<th style="width: 35%;">
						<div v-if="storeList.length < 1 && loadingStore == false">
							<a :href=shopewmdata.whatsapp target="_blank"><img :src="shopewmdata.whatsapp"
									:style="'max-width:150px'" /></a>
							<a :href=shopewmdata.shop target="_blank"><img :src="shopewmdata.shop"
									:style="'max-width:150px'" /></a>
							<!--
							<br />
							<el-button @click="downloadQR()">下載QR Code</el-button>
							<el-button @click="downloadQRPoster()">下載海報</el-button>-->
						</div>
					</th>
				</tr>

				<!--
				<tr>
					<th style="width: 13%;"></th>
					<th style="width: 10%;"></th>
					<th style="width: 15%;">
					</th>
					<th></th>
					<th style="width: 13%;">商戶QR</th>
					<th style="width: 35%;">
						<img :src="shopewmdata.whatsapp" :style="'max-width:120px'" />
						<br />
						<el-button @click="downloadQR()">下載QR Code</el-button>
						<el-button @click="downloadQRPoster()">下載海報</el-button>
					</th>
				</tr>-->
			</table>



		</div>


		<el-link style="font-size: 30px;margin : 10px">{{ $t("monthlyReport") }} (1/{{ valeuThisMonth }} - {{
			valueLastDayThisMonth }}/{{ valeuThisMonth }})</el-link>
		<div>
			{{ $t("searchByDate") }}:
			<el-date-picker v-model="starttime" type="date" :placeholder="$t('selectDate')">
			</el-date-picker> {{ $t("to") }}
			<el-date-picker v-model="endtime" type="date" :placeholder="$t('selectDate')">
			</el-date-picker>
			<el-button @click="search()">{{ $t("search") }}</el-button>
		</div>
		<el-skeleton style="--el-skeleton-circle-size: 360px" animated v-if="loadingStore == true">
			<template #template>
				<div style="    display: flex;flex-direction: column;width: 100%;align-items: center;margin-top:20px">
					<el-skeleton-item variant="circle" />
					<div class="label">{{ $t("loading") }}</div>
				</div>
			</template>
		</el-skeleton>

		<el-row :gutter="8" style="margin-top:20px" v-if="loadingStore == false">
			<el-col :xs="12" :span="6" :lg="12" v-for="item in storeList" :key="item.storeid">
				<el-card shadow="always">
					<div class="label">{{ item.storename }}<br />{{ $t("storeid") }}: {{ item.storeid }}</div>
					<div class="value">
						<a :href=item.whatsapp target="_blank"><img :src=item.whatsapp style="max-width:150px" /></a>
						<a :href=item.store target="_blank"><img :src=item.store style="max-width:150px" /></a>
					</div>
					<div style="width:100%; display: flex; flex-direction: row;">
						<el-tag type="warning" class="mx-1" effect="light" round
							style="text-align: center;min-height: 100px;height: auto;padding-top: 20px;color: #ffaa00; width: 24%;margin: 10px;white-space: normal;word-wrap: break-word;line-height: 20px;">
							<span style="font-weight: bold;font-size: 40px;">{{ item.sendNum }}</span><br /><span
								style="font-size: 14px;">{{ $t("boardcastMsgNumber") }}</span>
						</el-tag>
						<el-tag type="warning" class="mx-1" effect="light" round
							style="text-align: center;min-height:100px;height: auto;padding-top:20px;color: #ffaa00; width: 24%;margin:10px;white-space: normal;word-wrap: break-word;line-height: 20px;">
							<span style="font-weight: bold;font-size: 40px;">{{ item.huodongNum }}</span><br /><span
								style="font-size: 14px;">{{ $t("createCouponActivity") }}</span>
						</el-tag>
						<el-tag type="warning" class="mx-1" effect="light" round
							style="text-align: center;min-height:100px;height: auto;padding-top:20px;color: #ffaa00; width: 24%;margin:10px;white-space: normal;word-wrap: break-word;line-height: 20px;">
							<span style="font-weight: bold;font-size: 40px;">{{ item.totalmember }}</span><br /><span
								style="font-size: 14px;">{{ $t("memberNumber") }}</span>
						</el-tag>
						<el-tag type="warning" class="mx-1" effect="light" round
							style="text-align: center;min-height:100px;height: auto;padding-top:20px;color: #ffaa00; width: 24%;margin:10px;white-space: normal;word-wrap: break-word;line-height: 20px;">
							<span style="font-weight: bold;font-size: 40px;">{{ item.newmember }}</span><br /><span
								style="font-size: 14px;">{{ $t("addNewMember") }}</span>
						</el-tag>
					</div>
				</el-card>

			</el-col>
		</el-row>


		<el-row :gutter="8" v-if="storeList.length < 1 && loadingStore == false">
			<el-col :xs="2" :span="5" :lg="10" v-for="item in numberConfig" :key="item.label">
				<el-card shadow="">
					<div class="label">{{ item.label }}</div>
					<div class="value">{{ item.value }}</div>
				</el-card>
			</el-col>
		</el-row>


		<!-- 	 <div style="display: flex;margin-top: 20px;">
			 <div class="kaiqidiv">
				 <div>Whatsapp客服</div>
				 <div style="display: flex;">
					 <div style="flex:2;font-size: 35px;">已開啓</div>
					 <div style="flex:1;margin-top: 10px;text-align: right;">
									<el-switch
									  v-model="value0"
									  active-color="#aa0000"
									  inactive-color="#550000">
									</el-switch></div>
				 </div>
			 </div> -->
		<!-- 		 <div  class="kaiqidiv">
				 <div>電子排隊系統</div>
				 <div style="display: flex;">
				 					 <div style="flex:2;font-size: 35px;">關閉</div>
				 					 <div style="flex:1;margin-top: 10px;text-align: right;">
				 									<el-switch
				 									  v-model="value1"
				 									  active-color="#aa0000"
				 									  inactive-color="#550000">
				 									</el-switch></div>
				 </div>
			 </div>
			 <div  class="kaiqidiv">
				<div>電子預約系統</div>
				<div style="display: flex;">
									 <div style="flex:2;font-size: 35px;">已開啓</div>
									 <div style="flex:1;margin-top: 10px;text-align: right;">
													<el-switch
													  v-model="value0"
													  active-color="#aa0000"
													  inactive-color="#550000">
													</el-switch></div>
				</div>
			 </div>
	 
		 </div> -->

		<!-- 	<div style="display: flex;">
		 <el-calendar height='100px' style="flex:1;height: 100px;" v-model="value20"></el-calendar>
		 <el-calendar  style="flex:1;height: 100px;"  v-model="value2"></el-calendar>
		 <el-calendar  style="flex:1;height: 100px;"  v-model="value21"></el-calendar>
		</div> -->
		<!--	
 		<el-link style="font-size: 30px;;">接入指引</el-link>
		<div style="display: flex; width:90%;height: 200px;">
			<el-card style="flex:1;margin: 10px" shadow="always">
				<div class="label">个人Whatsapp</div>
				<div class="value"><el-button @click="setperson">进入</el-button></div>
			</el-card>		
			<el-card style="flex:1;margin: 10px"  shadow="always">
				<div class="label">企業Business API </div>
				<div class="value"><el-button @click="setqiye">进入</el-button></div>
			 
			</el-card>
		 
		</div>  
		-->
		<div v-if="moshi == 'person'">


			<div style="margin-top: 30px;;">
				<el-link style="font-size: 30px;;">接入个人whatsapp</el-link>
				<el-steps style="margin-top: 30px;;" :active="active">
					<el-step :title="count_page > 0 ? '已创建' : '创建店铺'" icon="el-icon-s-shop"></el-step>
					<el-step @click="jieruw()" title="接入Whatsapp" icon="el-icon-upload"></el-step>
					<el-step title="开始运行" icon="el-icon-circle-check"></el-step>
				</el-steps>
				<el-button v-if="active == 1" style="margin-top: 12px;" @click="dialogVisible = true">创建店铺</el-button>

				<!-- <a v-if="active == 2 "  :href="'#/wlogin?whatsapp='+pageid+'&pageid='+pageid">接入whatsapp{{pageid}}</a> -->

			</div>
			<!-- <el-calendar v-model="value"></el-calendar> -->

			<div v-if="active == 2" class="css-wgqwlq">
				<el-button v-if="active == 2" style="margin-top: 12px;" @click="jieruw">{{ but_txt }}</el-button>
				<div v-if="linking" class="tishi">{{ tishi }}</div>
				<div v-if="linking"> <img style="max-width: 200px;" v-if="ewm" :src="ewm" /></div>
				<div></div>
				<div class="tishi" v-if="loginfo.me">{{ loginfo.pushname }}{{ loginfo.me.user }}</div>
			</div>
		</div>


		<div v-if="moshi == 'qiye'">


			<div style="margin-top: 30px;;">
				<el-link style="font-size: 30px;;">接入企業whatsapp</el-link>
				<el-steps style="margin-top: 30px;;" :active="active">
					<el-step :title="count_page > 0 ? '已创建' : '创建店铺'" icon="el-icon-s-shop"></el-step>
					<el-step @click="jieruw()" title="接入API" icon="el-icon-upload"></el-step>
					<el-step title="开始运行" icon="el-icon-circle-check"></el-step>
				</el-steps>
				<el-button v-if="active == 1" style="margin-top: 12px;" @click="dialogVisible = true">创建店铺</el-button>

				<!-- <a v-if="active == 2 "  :href="'#/wlogin?whatsapp='+pageid+'&pageid='+pageid">接入whatsapp{{pageid}}</a> -->

			</div>

			<div v-if="active == 2" class="css-wgqwlq">
				<el-card class="box-card">
					<div slot="header" class="clearfix">
						<span>接入参数 </span> <a href="">官方</a>
					</div>
					<el-form :model="form1">
						<el-form-item :label="item.label" v-for="item in formConfig" :key="item.prop">
							<el-input v-model="form1[item.prop]" clearable></el-input>
						</el-form-item>
					</el-form>
					<el-button type="primary" @click="changeInfo" class="btn">{{ $t('submit') }}</el-button>
				</el-card>
			</div>
		</div>



		<!-- add renwu-->
		<el-dialog :title="$t('addDianpu')" :visible.sync="dialogVisible"
			:width="$store.state.isMobile ? '90%' : '556px'" :before-close="handleClose">
			<div class="add-template">
				<el-form ref="form" :model="form">
					<el-form-item :label="$t('listName')">
						<el-input v-model="form.name" type="textarea" :rows="2"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">{{ $t("Cancel") }}</el-button>
				<el-button type="primary" @click="adddianpu">{{ $t("Sure") }}</el-button>
			</span>
		</el-dialog>



	</div>

</template>
<script>
import { toUnixTime } from '../assets/dateToUnixTime.js'
import {
	tongji,
	getUserinfo, changeUserinfo,
	funk, getDaifalistNum, getSenderlistNum, getHuodongNum, getNewDaifalistNum, getStoreData, getStoreData3 ,getUserList
} from '@/api'
import userinfo from '@/mixins/userinfo'
export default {
	mixins: [userinfo],
	data() {
		return {
			loadingStore: true,
			starttime: '',
			endtime: '',
			value0: true,
			value1: false,
			value2: new Date(),
			valeuThisMonth: new Date().getMonth() + 1,
			valueLastDayThisMonth: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate(),
			value20: new Date() - 56400,
			value21: new Date() + 30,
			moshi: '',
			jsq: 0,
			but_txt: '接入whatsapp', tmp_txt: '',
			linking: false,
			tishi: '',
			time: '',
			whatsapp: '',
			ewm: '',
			shopewmdata: [],
			storeList: [],
			loginfo: [],
			vvv: Math.floor(new Date('2023-07-17 14:13:46').getTime() / 1000),
			form: {
				name: '',

			},
			formConfig: [

				{ label: this.$t('appid'), prop: 'appid', type: 'input' },
				{ label: this.$t('appsecret'), prop: 'appsecret', type: 'input' },
				{ label: this.$t('fromphone'), prop: 'fromphone', type: 'input' }
			],
			form1: {
				name: '', appid: '', appsecret: '', fromphone: '',
				mobile: '',
				address: ''
			},
			formUser: {
				qyid: '',
				start: "1-" + (new Date().getMonth() + 1) + "-" + new Date().getFullYear(),
				end: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getFullYear()
			},
			formStore: {
				qyid: '',
				start: "1-" + (new Date().getMonth() + 1) + "-" + new Date().getFullYear(),
				end: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getFullYear()
			},
			daifalistNum: 0,
			senderlistNum: 0,
			huodongNum: 0,
			dialogVisible: false,
			active: 1,
			qyid: 0,
            storeid: '',
			pageid: 0,
			count_page: 0,
			value: new Date(),
			tableData: [],
			user: [],
			numberConfig: [
				// {label: this.$t('todaytask'), value: '0'},
				{
					label: '發出訊息數量',
					value: '-'
				},
				// {label: this.$t('totalNumberOfCustomers'), value: '0'},
				/*
				{
					label: '閲讀數量',
					value: '-'
				},*/
				{
					label: '創建優惠劵活動',
					value: '-'
				},
				{
					label: '會員總數',
					value: '-'
				},
				{
					label: '新增會員',
					value: '-'
				},
				/*			{
					label: '點擊數量',
					value: '-'
				},*/
			]
		}
	},

	created() {
		var user = JSON.parse(window.localStorage.getItem('userinfo'))
        var auser = JSON.parse(window.localStorage.getItem('auserinfo'))
		console.log('userrrrrrrrrrrrrrrrr');
        console.log(user);
        console.log('auserrrrrrrrrrrrrrrrr');
        console.log(auser);
		this.user = user
		//this.qyid = user.id
        this.qyid = auser.qyid
        this.storeid = auser.storeid
		//this.getlist()
		//this.getUserinfo()

		console.log('formUser.end');

		console.log(this.formUser.start + ", " + this.formUser.end);
		//this.formUser.qyid = user.id;
		//this.formStore.qyid = user.id;
        this.formUser.qyid = auser.qyid;
		this.formStore.qyid = auser.qyid;
        // 會員總數
		getDaifalistNum(this.formUser).then(res => {
			console.log("getDaifalistNum")
			console.log(res)
			if (res.code == 1) {
				this.daifalistNum = res.count;
				this.numberConfig[2].value = res.count;
			} else {
				//this.$message.error(res.msg);
				this.numberConfig[2].value = 0;
			}
		})

		getSenderlistNum(this.formUser).then(res => {
			console.log('valueLastDayThisMonth')
			console.log((new Date().getMonth() + 1) + "-" + new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate() + "-" + new Date().getFullYear())
			if (res.code == 1) {
				this.senderlistNum = res.count;
				this.numberConfig[0].value = res.count;
			} else {
				//this.$message.error(res.msg);
				this.numberConfig[0].value = 0;
			}
		})
		getHuodongNum(this.formUser).then(res => {
			if (res.code == 1) {
				this.huodongNum = res.count;
				this.numberConfig[1].value = res.count;
			} else {
				//this.$message.error(res.msg);
				this.numberConfig[1].value = 0;
			}
		})
		getNewDaifalistNum(this.formUser).then(res => {
			console.log("getNewDaifalistNum")
			console.log(res)
			if (res.code == 1) {
				//this.daifalistNum = res.count;
				this.numberConfig[3].value = res.count;
			} else {
				//this.$message.error(res.msg);
				this.numberConfig[3].value = 0;
			}
		})
		this.getShopEWM();
		this.getStoreEWM();



	},
	mounted() {
		window.onbeforeunload = e => {
			console.log("onloaod: ");
			clearInterval(this.timer);
		}

	},
	watch: {
		userinfo(val) {
			console.log('val', val)
			this.url = 'https://w9.nowaittech.com/app/index.php?i=1&c=entry&m=qicheng_messenger&do=shouquan_whatsapp&state=' + val.id
			this.form1.name = val.name || ''
			this.form1.contract = val.contract || ''
			this.form1.mobile = val.mobile || ''
			this.form1.address = val.address || ''
			this.form1.qyid = val.id
			this.form1.appid = val.appid
			this.form1.fromphone = val.fromphone
			this.form1.appsecret = val.appsecret
		},
		value20(val) {
			console.log('a', val);
		},
	},
	methods: {
		
		downloadQR() {
			const url = this.shopewmdata.whatsapp;
			window.open(url);
		},
		downloadQRPoster() {
			const url = this.shopewmdata.shop;
			window.open(url);
		},
		getShopEWM() {
			//var user = JSON.parse(window.localStorage.getItem('userinfo'))
			//console.log(user);
			//this.qyid = user.id

			let fdata = {
				qyid: this.qyid
			}

			tongji(fdata).then(res => {
				if (res.code == 1) {
					//console.log(res);
					this.tableData = res.data
					this.count_page = res.data.count_page
					if (this.count_page > 0) {
						this.active = 2
						//	this.jieruw()
					}
					this.pageid = res.data.pageid
					let fdata2 = {
						do: 'ewm_shop',
						qyid: this.qyid,
						pageid: res.data.pageid,
						ref: "HI",
						type: 'link',


					}
					//console.log('go ewm', fdata2);

					funk(fdata2).then(res => {
						if (res.code == 1) {
							console.log(res);
							this.shopewmdata = res
							console.log('shopewmdata')
							console.log(this.shopewmdata)
							// const html ='<div style="text-algin:center;">H5:<a target="_blank"  href="'+res.url+'">link</a> <br><img src='+res.path+' /> <br>Whatsapp:<a target="_blank"  href="'+res.wurl+'">link</a> <button class="tag-read" :data-clipboard-text="aaa" @click="copy">复制</button></el-button><br> <img src='+res.whatsapp+' /> <br></div>' 
							// this.$alert(html, '預約排隊二維碼', {
							//           dangerouslyUseHTMLString: true
							//         });


						} else {
							this.$message({
								type: 'error',
								message: res.msg
							})
						}
					})

				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})


		},
		getStoreEWM() {
			//var user = JSON.parse(window.localStorage.getItem('userinfo'))
			console.log('getStoreEWMMMMMMMMMMMMMMMMMMMMMMMMMMMM');
			//this.qyid = user.id

			
			//console.log('go ewm', fdata2);

			if(this.storeid == null) {
				console.log('storeid nullllllllllllllllllllllllll: ' + this.storeid)
				let fdata2 = {
					do: 'ewm_store',
					qyid: this.qyid,
					ref: "HI",
					type: 'link',
				}
				funk(fdata2).then(res => {
					console.log('storeewmdatassssssssssssssssssssssss')
					console.log(res)
					this.storeList = res;
					this.loadingStore = false;

                    /*
					for (let i = 0; i < this.storeList.length; i++) {
						console.log('storeList: ' + this.storeList[i]['storeid'])
						//this.formStore.storeid = this.storeList[i]['storeid']


						let senddata = this.formStore
						senddata.storeid = this.storeList[i]['storeid']
						//this.sleep(1000)
						getStoreData(senddata).then(resp => {
							this.storeList[i]['totalmember'] = resp.totalMember
							this.storeList[i]['newmember'] = resp.newMember
							this.storeList[i]['huodongNum'] = resp.huodongNum
							this.storeList[i]['sendNum'] = resp.sendNum
							console.log('sdata: ' + senddata.storeid)
							console.log(resp)
							this.loadingStore = true;
							this.loadingStore = false;
							console.log(this.storeList)
						})

					}*/

                    let senddata = this.formStore
					//senddata.storeid = this.storeList[i]['storeid']     
                    getStoreData3(senddata).then(resp => {
                        let countsMap_totalmember = {};
                        let countsMap_newmember = {};
                        let countsMap_huodongnum = {};
                        let countsMap_sendnum = {};
                        resp.totalMember333.forEach(item => {
                            countsMap_totalmember[item.storeid] = item.whatsapp_count;
                        });
                        resp.newMember333.forEach(item => {
                            countsMap_newmember[item.storeid] = item.whatsapp_count;
                        });
                        resp.huodongNum333.forEach(item => {
                            countsMap_huodongnum[item.storeid] = item.huodong_count;
                        });
                        resp.sendNum333.forEach(item => {
                            countsMap_sendnum[item.storeid] = item.send_count;
                        });

                        this.storeList.forEach(store => {
                            store.totalmember = countsMap_totalmember[store.storeid] || 0
                            store.newmember = countsMap_newmember[store.storeid] || 0
                            store.huodongNum = countsMap_huodongnum[store.storeid] || 0
                            store.sendNum = countsMap_sendnum[store.storeid] || 0
                        })
                        this.loadingStore = true;
                        this.loadingStore = false;
                    })







				})
			}
			else {
				console.log('storeidddddddddddddddddddddddddddd: ' + this.storeid)
				let fdata2 = {
					do: 'ewm_store_onestore',
					qyid: this.qyid,
					storeid: this.storeid,
					ref: "HI",
					type: 'link',
				}
				funk(fdata2).then(res => {
					console.log('storeewmdatassssssssssssssssssssssss')
					console.log(res)
					this.storeList = res;
					this.loadingStore = false;

                    /*
					for (let i = 0; i < this.storeList.length; i++) {
						console.log('storeListtttttttttttttttttttt: ' + this.storeList[i]['storeid'])
						//this.formStore.storeid = this.storeList[i]['storeid']


						let senddata = this.formStore
						senddata.storeid = this.storeList[i]['storeid']
						//this.sleep(1000)
						getStoreData(senddata).then(resp => {
							this.storeList[i]['totalmember'] = resp.totalMember
							this.storeList[i]['newmember'] = resp.newMember
							this.storeList[i]['huodongNum'] = resp.huodongNum
							this.storeList[i]['sendNum'] = resp.sendNum
							console.log('sdata: ' + senddata.storeid)
							console.log(resp)
							this.loadingStore = true;
							this.loadingStore = false;
							console.log(this.storeList)
						})

					}
                    */

                    let senddata = this.formStore
					//senddata.storeid = this.storeList[i]['storeid']     
                    getStoreData3(senddata).then(resp => {
                        let countsMap_totalmember = {};
                        let countsMap_newmember = {};
                        let countsMap_huodongnum = {};
                        let countsMap_sendnum = {};
                        resp.totalMember333.forEach(item => {
                            countsMap_totalmember[item.storeid] = item.whatsapp_count;
                        });
                        resp.newMember333.forEach(item => {
                            countsMap_newmember[item.storeid] = item.whatsapp_count;
                        });
                        resp.huodongNum333.forEach(item => {
                            countsMap_huodongnum[item.storeid] = item.huodong_count;
                        });
                        resp.sendNum333.forEach(item => {
                            countsMap_sendnum[item.storeid] = item.send_count;
                        });

                        this.storeList.forEach(store => {
                            store.totalmember = countsMap_totalmember[store.storeid] || 0
                            store.newmember = countsMap_newmember[store.storeid] || 0
                            store.huodongNum = countsMap_huodongnum[store.storeid] || 0
                            store.sendNum = countsMap_sendnum[store.storeid] || 0
                        })
                        this.loadingStore = true;
                        this.loadingStore = false;
                    })





				})
			}

			
			






		},
		sleep(time) {
			return new Promise((resolve) => setTimeout(resolve, time));
		},
		search() {
			let start_date = new Date(this.starttime).getDate() + '-' + (new Date(this.starttime).getMonth() + 1) + '-' + new Date(this.starttime).getFullYear();
			let end_date = new Date(this.endtime).getDate() + '-' + (new Date(this.endtime).getMonth() + 1) + '-' + new Date(this.endtime).getFullYear();
			//console.log('search: ' + new Date(this.starttime).getDate() + '-' + (new Date(this.starttime).getMonth()+ 1) + '-' + new Date(this.starttime).getFullYear() + ', ' + this.endtime);



			console.log('start_date: ' + start_date + ' end_date:, ' + end_date);

			let formSearch = {
				qyid: this.user.id,
				start: start_date,
				end: end_date
			}
			getSenderlistNum(formSearch).then(res => {
				//console.log('valueLastDayThisMonth')
				//console.log((new Date().getMonth() + 1) + "-" + new Date(new Date().getFullYear(), new Date().getMonth()+1, 0).getDate() +"-" + new Date().getFullYear())
				if (res.code == 1) {
					this.senderlistNum = res.count;
					this.numberConfig[0].value = res.count;
				} else {
					//this.$message.error(res.msg);
					this.numberConfig[0].value = 0;
				}
			})
			getHuodongNum(formSearch).then(res => {
				if (res.code == 1) {
					this.huodongNum = res.count;
					this.numberConfig[1].value = res.count;
				} else {
					//this.$message.error(res.msg);
					this.numberConfig[1].value = 0;
				}
			})
			getDaifalistNum(formSearch).then(res => {
				console.log("getDaifalistNum")
				console.log(res)
				if (res.code == 1) {
					this.daifalistNum = res.count;
					this.numberConfig[2].value = res.count;
				} else {
					//this.$message.error(res.msg);
					this.numberConfig[2].value = 0;
				}
			})
			getNewDaifalistNum(formSearch).then(res => {
				console.log("getNewDaifalistNum")
				console.log(res)
				if (res.code == 1) {
					//this.daifalistNum = res.count;
					this.numberConfig[3].value = res.count;
				} else {
					//this.$message.error(res.msg);
					this.numberConfig[3].value = 0;
				}
			})


            /*
			for (let i = 0; i < this.storeList.length; i++) {
				console.log('storeList: ' + this.storeList[i]['storeid'])
				//this.formStore.storeid = this.storeList[i]['storeid']


				let senddata = this.formStore
				senddata.storeid = this.storeList[i]['storeid']
				senddata.start = start_date
				senddata.end = end_date
				//this.sleep(1000)
				getStoreData(senddata).then(resp => {
					this.storeList[i]['totalmember'] = resp.totalMember
					this.storeList[i]['newmember'] = resp.newMember
					this.storeList[i]['huodongNum'] = resp.huodongNum
					this.storeList[i]['sendNum'] = resp.sendNum
					console.log('sdata: ' + senddata.storeid)
					console.log(resp)
					this.loadingStore = true;
					this.loadingStore = false;
					console.log(this.storeList)
				})

			}*/

            let senddata = this.formStore
            senddata.start = start_date
			senddata.end = end_date
            //senddata.storeid = this.storeList[i]['storeid']     
            getStoreData3(senddata).then(resp => {
                let countsMap_totalmember = {};
                let countsMap_newmember = {};
                let countsMap_huodongnum = {};
                let countsMap_sendnum = {};
                resp.totalMember333.forEach(item => {
                    countsMap_totalmember[item.storeid] = item.whatsapp_count;
                });
                resp.newMember333.forEach(item => {
                    countsMap_newmember[item.storeid] = item.whatsapp_count;
                });
                resp.huodongNum333.forEach(item => {
                    countsMap_huodongnum[item.storeid] = item.huodong_count;
                });
                resp.sendNum333.forEach(item => {
                    countsMap_sendnum[item.storeid] = item.send_count;
                });

                this.storeList.forEach(store => {
                    store.totalmember = countsMap_totalmember[store.storeid] || 0
                    store.newmember = countsMap_newmember[store.storeid] || 0
                    store.huodongNum = countsMap_huodongnum[store.storeid] || 0
                    store.sendNum = countsMap_sendnum[store.storeid] || 0
                })
                this.loadingStore = true;
                this.loadingStore = false;
            })



		},
		goToPay() {
			//console.log('gogoooo')
			this.$router.push('/packagePurchase');
		},
		setperson() {
			// this.$message('即将开通')
			// return 
			this.moshi = 'person'
		},
		setqiye() {
			this.moshi = 'qiye'
			var user = JSON.parse(window.localStorage.getItem('user'))
			console.log('user:', user);

			this.form1.username = user.username
			this.form1.password = user.password
			this.form1.fromphone = user.fromphone
			this.form1.appid = user.appid
			this.form1.appsecret = user.appsecret
			this.getUserinfo()
		},
		jieruw() {
			this.jsq = 0
			if (this.active != 2) return

			if (!this.linking) {
				console.log("begin linnk..: ");
				this.but_txt = '正在接入'

				this.timer = setInterval(this.whatslogin, 2000);
			} else {
				this.but_txt = '重新接入'
				console.log("stopped: ");
				clearInterval(this.timer);
			}
			this.linking = !this.linking
			console.log('jieruw');
		},
		getUserinfo() {
			var user = JSON.parse(window.localStorage.getItem('userinfo'))
			let fdata = {
				qyid: user.id
			}
			getUserinfo(fdata).then(res => {
				if (res.code == 1) {
					console.log(res);
					window.localStorage.setItem('userinfo', JSON.stringify(res.data))
					this.numberConfig[1].value = res.data.nums
					this.numberConfig[2].value = res.data.lasttime
					this.form1.appid = res.data.appid
					this.form1.fromphone = res.data.fromphone

					this.form1.appsecret = res.data.appsecret
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},
		getlist() {
			var user = JSON.parse(window.localStorage.getItem('userinfo'))
			let fdata = {
				qyid: user.id
			}
			tongji(fdata).then(res => {
				if (res.code == 1) {
					console.log(res);
					this.tableData = res.data
					this.count_page = res.data.count_page
					if (this.count_page > 0) {
						this.active = 2
						//	this.jieruw()
					}
					this.pageid = res.data.pageid
					//this.numberConfig[0].value = res.data.count_sendrwlist
					//this.numberConfig[1].value = res.data.count_templatelist
					// this.numberConfig[2].value=res.data.count_daifalist

				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},

		adddianpu() {
			console.log('go taocan');
			var user = JSON.parse(window.localStorage.getItem('userinfo'))

			let fdata = {
				do: 'api_dianpu_insert',
				qyid: user.id,
				name: this.form.name,


			}

			funk(fdata).then(res => {
				if (res.code == 1) {
					console.log(res);
					location.reload()

				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})


		},
		handleClose() {
			this.dialogVisible = false;

		},

		//login w
		whatslogin() {
			this.jsq++
			var yushu = this.jsq % 3
			var str = ''
			for (i = 0; i <= yushu; i++) {
				str += '.'
			}

			this.but_txt = str + '正在接入' + str
			if (this.jsq >= 20) {
				this.linking = false
				this.but_txt = '重新接入'
				clearInterval(this.timer);
				return
			}
			let fdata = {
				do: 'api_whatsapp_login',
				action: 'begin',
				whatsapp: this.pageid,
			}
			funk(fdata).then(res => {
				console.log(res);
				console.log(res.code);
				this.tishi = res.msg
				if (res.code < 0) {
					this.tishi = res.msg
					clearInterval(this.timer);
				}
				if (res.ewm) {
					this.ewm = res.ewm
				}
				if (res.code == 0) {
					console.log('clear..');
					this.active = 3
					clearInterval(this.timer);
					this.whatsinfo()
					// this.whatsapp=''


				}
			})

		},
		whatsinfo() {
			let fdata = {
				do: 'api_whatsapp_login',
				action: 'info',
				whatsapp: this.whatsapp,
				qyid: this.qyid,
				pageid: this.pageid

			}
			funk(fdata).then(res => {
				console.log(res);
				this.loginfo = res

			})

		},
		changeInfo() {
			if (this.form1.appid && this.form1.appsecret) {
				changeUserinfo(this.form1).then(res => {
					if (res.code == '1') {
						this.$message({
							message: res.msg,
							type: 'success'
						})
						this.getUserinfo()

					} else {
						this.$message({
							message: res.msg,
							type: 'warning'
						})
					}
				})
			} else {
				this.$message({
					message: this.$t('pleaseFillInTheInformation'),
					type: 'warning'
				})
			}
		}






	}

};
</script>
<style lang="scss" scoped>
.kaiqidiv {
	flex: 1;
	background-color: antiquewhite;
	border-radius: 5px;
	padding: 10px;
	margin-right: 30px;
}

.home-wrapper {
	width: 100%;

	.label {
		font-size: 24px;
		font-weight: bold;
		color: rgba(0, 0, 0, .45);
	}

	.value {
		text-align: right;
		width: 100%;
		font-weight: bold;
		font-size: 50px;
		color: #ffaa00;

	}

	.btn {
		font-size: 26px;

		right: 2px;
		bottom: 0px;
	}
}

@media screen and (max-width: 768px) {
	.home-wrapper {
		.label {
			font-size: 12px;
			text-align: center;
		}

		.value {
			font-size: 14px;
		}
	}

	::v-deep .el-card__body {
		padding: 16px;
	}

	::v-deep .el-calendar-table .el-calendar-day {
		height: 40px;
	}
}

.css-wgqwlq {
	background-color: rgb(255, 255, 255);
	color: rgb(35, 41, 52);
	transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
	border-radius: 8px;
	box-shadow: rgb(93 104 125 / 6%) 0px 0px 9px, rgb(93 104 125 / 3%) 0px 0px 1px;
	background-image: none;
	overflow: hidden;
	width: 50%;
	margin-left: 25%;
	margin-top: 1%;
	text-align: center;
}

.tishi {
	height: 100px;
	line-height: 100px;
	font-size: 25px;
}
</style>
